import { topicsData } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-hashtag"></i>
              话题广场
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              全网吃瓜群众都在讨论的热门话题标签
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#cards"
                className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full transition-all duration-200 cursor-pointer ${
                  topic.hot
                    ? 'bg-primary-100 text-primary-700 border-2 border-primary-200 hover:bg-primary-200 hover:border-primary-300'
                    : 'bg-background-100 text-foreground-600 border border-background-200/70 hover:border-primary-200 hover:text-primary-500'
                }`}
              >
                <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
                <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold ${
                  topic.hot
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {topic.count}
                </span>
                {topic.hot && (
                  <i className="ri-fire-line text-[10px] text-primary-500"></i>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}